var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E200A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.25581C11.723 8.25581 8.25581 11.723 8.25581 16C8.25581 20.277 11.723 23.7442 16 23.7442C20.277 23.7442 23.7442 20.277 23.7442 16C23.7442 11.723 20.277 8.25581 16 8.25581ZM7 16C7 11.0294 11.0294 7 16 7C20.9706 7 25 11.0294 25 16C25 20.9706 20.9706 25 16 25C11.0294 25 7 20.9706 7 16Z",
    fill: "#E200A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9071 13.572C13.7221 13.572 13.5722 13.722 13.5722 13.9069C13.5722 14.0919 13.7221 14.2418 13.9071 14.2418C14.092 14.2418 14.2419 14.0919 14.2419 13.9069C14.2419 13.722 14.092 13.572 13.9071 13.572ZM12.5675 13.9069C12.5675 13.1671 13.1672 12.5674 13.9071 12.5674C14.6469 12.5674 15.2466 13.1671 15.2466 13.9069C15.2466 14.6467 14.6469 15.2465 13.9071 15.2465C13.1673 15.2465 12.5675 14.6468 12.5675 13.9069Z",
    fill: "#E200A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.093 17.7581C17.9081 17.7581 17.7581 17.908 17.7581 18.093C17.7581 18.2779 17.9081 18.4278 18.093 18.4278C18.278 18.4278 18.4279 18.2779 18.4279 18.093C18.4279 17.908 18.278 17.7581 18.093 17.7581ZM16.7535 18.093C16.7535 17.3532 17.3532 16.7534 18.093 16.7534C18.8328 16.7534 19.4325 17.3532 19.4325 18.093C19.4325 18.8328 18.8328 19.4325 18.093 19.4325C17.3532 19.4325 16.7535 18.8328 16.7535 18.093Z",
    fill: "#E200A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9556 13.0443C19.2008 13.2895 19.2008 13.687 18.9556 13.9323L13.9324 18.9555C13.6872 19.2007 13.2896 19.2007 13.0444 18.9555C12.7992 18.7103 12.7992 18.3127 13.0444 18.0675L18.0676 13.0443C18.3129 12.799 18.7104 12.799 18.9556 13.0443Z",
    fill: "#E200A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommission);
export default __webpack_public_path__ + "static/media/commission.c0d4ca1a53f3a41d3b4dc63d78f7917a.svg";
export { ForwardRef as ReactComponent };